import api from './api';

const URL_PREFIX = '/lists/';

class ListService {
    searchLists(searchTerm, page, limit) {
        return api.get(URL_PREFIX + 'searchLists', {
            params: {
                searchTerm,
                page,
                limit,
            },
        });
    }

    upvoteList(listId, upvote) {
        return api.post(URL_PREFIX + 'upvoteList/' + listId, { upvote });
    }

    getCurrency(ip) {
        return api.get(URL_PREFIX + 'getCurrency', {
            params: {
                ip,
            },
        });
    }
}

const listServiceInstance = new ListService();

export default listServiceInstance;